export default {
  seo: {
    title: 'Configuración de SEO',
    types: {
      defaultGlobe: 'Global por Defecto',
      home: 'Inicio',
      // compat old keys
      promotionList: 'Lista de Promociones',
      promotionDetail: 'Detalle de Promoción',
      pointsMall: 'Centro de Puntos',
      aiRecommend: 'Recomendación de IA',
      helpCenter: 'Centro de Ayuda',
      helpArticleDetail: 'Detalle de Artículo de Ayuda',
      // new backend typeKey
      'promo-list': 'Lista de Promociones',
      'promo-detail': 'Detalle de Promoción',
      points: 'Centro de Puntos',
      'ai-picks': 'Selecciones de IA',
      'help-index': 'Centro de Ayuda',
      'help-article': 'Detalle de Artículo de Ayuda',
      vip: 'Página VIP',
      'vip-rules': 'Reglas VIP'
    },
    form: {
      searchLabel: 'Buscar',
      searchPlaceholder: 'Buscar por nombre / palabra clave',
      query: 'Consultar',
      reset: 'Restablecer',
      add: 'Nueva Página',
      languageLabel: 'Idioma',
      languagePh: 'Seleccionar idioma',
      typeLabel: 'Tipo de Página',
      typeAll: 'Todos',
      statusLabel: 'Estado',
      statusAll: 'Todos',
      statusEnabled: 'Habilitado',
      statusDisabled: 'Deshabilitado'
    },
    table: {
      name: 'Nombre de Página',
      isGlobalTag: 'Global',
      dynamicParams: 'Parámetros Dinámicos',
      yes: 'Sí',
      no: 'No',
      coreSeo: 'SEO Principal',
      socialOg: 'OG Social',
      enabled: 'Habilitado',
      action: 'Acción',
      edit: 'Editar',
      preview: 'Previsualizar',
      delete: 'Eliminar',
      total: 'Total {{count}} elementos',
      updatedByText: 'Actualizado: {{updatedAt}} · Por: {{updatedBy}}',
      keywordPrefix: 'Palabra clave: {{text}}',
      ogImageHas: 'Imagen',
      ogImageNone: 'Sin Imagen',
      ogTitleShort: 'OGT: {{text}}',
      ogDescShort: 'OGD: {{text}}',
      ogKeywordShort: 'OGK: {{text}}',
      ogImageConfigured: 'Configurado',
      ogImageNotConfigured: 'No Configurado'
    },
    modal: {
      createTitle: 'Crear Página',
      editTitle: 'Editar Página',
      previewTitle: 'Previsualizar',
      fields: {
        type: 'Tipo de Página',
        typePh: 'Seleccionar tipo de página',
        name: 'Nombre de Página',
        namePh: 'Identificador único, ej. home, promotion-detail',
        enabled: 'Habilitado',
        isGlobal: 'Global',
        hasOG: 'Tiene Información OG',
        hasDynamicParams: 'Tiene Parámetros Dinámicos',
        paramNames: 'Nombres de Parámetros',
        paramNamesPh: 'ej. id, slug (separados por coma)',
        title: 'Título',
        titlePh: 'Soporta {{pageTitle}}',
        meta: 'Descripción Meta',
        metaPh: 'Resumen de página',
        canonical: 'Canónico',
        canonicalPh: 'Enlace canónico',
        keyword: 'Palabra clave',
        keywordPh: 'Separadas por coma',
        ogTitle: 'Título OG',
        ogDesc: 'Descripción OG',
        ogKeyword: 'Palabra Clave OG',
        ogImage: 'URL de Imagen OG',
        ogImagePh: 'https://...'
      },
      ok: 'Aceptar',
      cancel: 'Cancelar',
      deleteConfirmTitle: 'Confirmar Eliminación',
      deleteConfirmContent: '¿Eliminar página "{{name}}"?'
    },
    message: {
      queryFailed: 'Consulta fallida',
      createSuccess: 'Creado',
      createFailed: 'Creación fallida',
      updateSuccess: 'Actualizado',
      updateFailed: 'Actualización fallida',
      opFailed: 'Operación fallida',
      enabled: 'Habilitado',
      disabled: 'Deshabilitado',
      deleteSuccess: 'Eliminado',
      deleteFailed: 'Eliminación fallida'
    }
  }
};


